import React from 'react'
import CallIcon from '@mui/icons-material/Call'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import { MotionButton, MotionCard, MotionIcon, MotionSection } from '../motion/Motion'

export default function ContactFormSection() {
  return (
    <MotionSection className="w-[96%] sm:w-[92%] md:w-[90%] lg:w-[90%] mx-auto pb-12 lg:pb-16">
      <div className="grid gap-8 lg:grid-cols-[360px_1fr] lg:items-stretch">
        <MotionCard className="bg-white border border-gray-100 rounded-lg shadow-sm p-5 sm:p-6 md:p-7 lg:p-8" delay={0.02}>
          <div>
            <div className="flex items-center gap-4">
              <div className="h-12 w-12 rounded-full bg-pink-500 text-white flex items-center justify-center flex-shrink-0">
                <MotionIcon>
                  <CallIcon fontSize="small" className="text-white" />
                </MotionIcon>
              </div>
              <h3 className="font-semibold text-gray-900">Call To Us</h3>
            </div>
            <div className="mt-4 space-y-4">
              <p className="text-sm text-gray-600">We are available 24/7, 7 days a week.</p>
              <p className="text-sm text-gray-800">Phone: +260981282836</p>
            </div>
          </div>

          <div className="my-8 h-px bg-gray-200" />

          <div>
            <div className="flex items-center gap-4">
              <div className="h-12 w-12 rounded-full bg-pink-500 text-white flex items-center justify-center flex-shrink-0">
                <MotionIcon>
                  <MailOutlineIcon fontSize="small" className="text-white" />
                </MotionIcon>
              </div>
              <h3 className="font-semibold text-gray-900">Write To Us</h3>
            </div>
            <div className="mt-4 space-y-4">
              <p className="text-sm text-gray-600">Fill out our form and we will contact you within 24 hours.</p>
              <p className="text-sm text-gray-800">Email: Care@logobrandeddoormats.co.zm</p>
            </div>
          </div>
        </MotionCard>

        <MotionCard className="bg-white border border-gray-100 rounded-lg shadow-sm p-5 sm:p-6 md:p-7 lg:p-8" delay={0.08}>
          <form action="https://formsubmit.co/Care@logobrandeddoormats.co.zm" method="POST">
          <div className="grid gap-4 sm:grid-cols-3">
            <input
              type="text"
              name="name"
              required
              className="w-full bg-gray-100 rounded-md px-4 py-3 text-sm text-gray-800 placeholder:text-gray-500 outline-none focus:ring-2 focus:ring-pink-400"
              placeholder="Your Name *"
            />
            <input
              type="email"
              name="email"
              required
              className="w-full bg-gray-100 rounded-md px-4 py-3 text-sm text-gray-800 placeholder:text-gray-500 outline-none focus:ring-2 focus:ring-pink-400"
              placeholder="Your Email *"
            />
            <input
              type="tel"
              name="phone"
              required
              className="w-full bg-gray-100 rounded-md px-4 py-3 text-sm text-gray-800 placeholder:text-gray-500 outline-none focus:ring-2 focus:ring-pink-400"
              placeholder="Your Phone *"
            />
          </div>

          <div className="mt-4">
            <textarea
              name="message"
              required
              className="w-full bg-gray-100 rounded-md px-4 py-3 text-sm text-gray-800 placeholder:text-gray-500 outline-none focus:ring-2 focus:ring-pink-400 min-h-[220px] resize-none"
              placeholder="Your Message"
            />
          </div>

          <input type="hidden" name="_subject" value="New Contact Form Submission - Logo Branded Door Mats" />
          <input type="hidden" name="_captcha" value="false" />
          <input type="hidden" name="_template" value="table" />

          <div className="mt-6 flex justify-end">
            <button
              type="submit"
              className="bg-pink-500 hover:bg-pink-600 transition-colors text-white font-semibold text-sm px-10 py-3 rounded-md"
            >
              <MotionButton>Send Message</MotionButton>
            </button>
          </div>
          </form>
        </MotionCard>
      </div>
    </MotionSection>
  )
}
